import SocialMediaIcons from "../components/SocialMediaIcons";

const Footer = () => {
  return (
    <footer className="h-64 bg-cyan-500 pt-10">
      <div className="w-10/12 mx-auto">
        <SocialMediaIcons />
        <div className="md:flex justify-center md:justify-between text-center ">
          <p className=" font-bold font-opensans text-2xl text-deep-blue">
            LUBABA AUNJUM
          </p>
          <p className="font-playfair text-md text-deep-blue">
            Thanks for visiting my portfolio
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
